import React, { Component } from 'react';
import { Grid, Row, Col, Form, FormGroup, ControlLabel, ButtonGroup, Button } from 'react-bootstrap';
import { PropTypes } from 'prop-types';

export class ExportForm extends Component {
    static contextTypes = {
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            model: {
                date: undefined,
                exportType: 1
            },
            dateInputError: null
        }
    }

    componentDidMount() {
        const { model } = this.state;

        this.context.addEditionObserver(this);
        this.props.onChangeFormModel(model);
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // -----------------

    endUpdate(edition) {
        this.onSelectValue(this.parseDate(edition.date), "date");
    }

    // -----------------

    onSelectValue(e, property) {
        const { model } = this.state;

        model[property] = e;

        this.setState({
            model: model
        });
        this.props.onChangeFormModel(model);
    }

    // -------------------

    parseDate(date) {
        if (date instanceof Date) {
            return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
        }

        return date;
    }

    // -------------------

    render() {
        const { model } = this.state;

        return (
            <Grid fluid className="margin-top-10">
                <Row>
                    <Col sm={12}>
                        <Form>
                            <FormGroup>
                                <ControlLabel>Formato de Dados</ControlLabel>
                                <ButtonGroup style={{ marginLeft: "10px" }}>
                                    <Button active={1 === model.exportType} 
                                        bsStyle={1 === model.exportType ? "primary" : "default"} 
                                        onClick={() => this.onSelectValue(1, "exportType")}>
                                            GTFS
                                    </Button>
                                    <Button active={2 === model.exportType} 
                                        bsStyle={2 === model.exportType ? "primary" : "default"} 
                                        onClick={() => this.onSelectValue(2, "exportType")}>
                                            NETEX
                                    </Button>
                                </ButtonGroup>
                            </FormGroup>
                        </Form>
                    </Col>
                </Row>
            </Grid>
        );
    }
}
